import { render, staticRenderFns } from "./POIOverlay.vue?vue&type=template&id=07a18eda&scoped=true&"
import script from "./POIOverlay.vue?vue&type=script&lang=js&"
export * from "./POIOverlay.vue?vue&type=script&lang=js&"
import style0 from "./POIOverlay.vue?vue&type=style&index=0&id=07a18eda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a18eda",
  null
  
)

export default component.exports